import { render, staticRenderFns } from "./assigned_mr.vue?vue&type=template&id=3beaffaf&"
import script from "./assigned_mr.vue?vue&type=script&lang=js&"
export * from "./assigned_mr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports